import { Component, Input, OnInit } from '@angular/core';
import { NotificationClient } from '../../../client/notification.client';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CleanEmailImgHtmlPipe } from '../../pipes/clearEmailImgTag.pipe';


export interface EmailItem {
    trackingToken: string;
    from: string;
    fromMailboxName: string;
    createdOn: Date;
    to: string;
    subject: string;
    description: string;
}

@Component({
    selector: 'app-ticket-emails',
    templateUrl: './ticket-emails.component.html',
    styleUrls: ['./ticket-emails.component.scss']
})
export class TicketEmailsComponent implements OnInit {
    @Input() notificationId: number;

    emails: EmailItem[] = [];
    loading: boolean = false;

    constructor(
        private notificationClient: NotificationClient,
        private sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
        if (this.notificationId) {
            this.loadEmailConversation();
        }
    }

    private loadEmailConversation(): void {
        this.loading = true;
        this.notificationClient
            .getTicketNotificationConversation(this.notificationId)
            .then((response) => {
                this.emails = (response?.result || []).sort((a, b) =>
                    new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
                );
                this.loading = false;
            })
            .catch((error) => {
                console.error('Error loading email conversation:', error);
                this.loading = false;
            });
    }

    getSafeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    getFromDisplay(email: EmailItem): string {
        if (email.fromMailboxName) {
            return `${email.from} (${email.fromMailboxName})`;
        }
        return email.from;
    }
}